const validatePasswordConfirmation = (newPassword, passwordConfirmation) => {
    if (!passwordConfirmation) {
        return 'Insira a confirmação de senha.';
    }

    if (newPassword !== passwordConfirmation) {
        return 'A confirmação não é igual a senha.';
    }
}

const validateCurrentPassword = (password) => {
    if (!password) {
        return 'Insira a senha atual.';
    }
}

const validateNewPassword = (password) => {
    if (!password) {
        return 'Insira a nova senha.';
    }
}

const validations = ({ password, new_password, password_confirmation }) => ({
    current_password: validateCurrentPassword(password),
    new_password: validateNewPassword(new_password),
    password_confirmation: validatePasswordConfirmation(new_password, password_confirmation)
});

export default validations;


// WEBPACK FOOTER //
// ./src/components/Pages/ChangePassword/validations.js